const abortError = () => Object.assign(new Error('Análise cancelada.'), { name: 'AbortError' });
const pause = (milliseconds, signal) => new Promise((resolve, reject) => {
    if (signal?.aborted) { reject(abortError()); return; }
    const abort = () => { clearTimeout(timer); signal?.removeEventListener('abort', abort); reject(abortError()); };
    const timer = setTimeout(() => { signal?.removeEventListener('abort', abort); resolve(); }, milliseconds);
    signal?.addEventListener('abort', abort, { once: true });
});

// Poll only the operation's status; never resubmit a start or approved write.
export async function waitForMonitoringCorrectionJob(initial, { getStatus, onProgress = () => {}, signal, pollInterval = 1500, maxDuration = 30 * 60 * 1000 }) {
    const startedAt = Date.now();
    let operation = initial;
    for (;;) {
        if (signal?.aborted) throw abortError();
        onProgress(operation.progress || {});
        if (operation.status === 'complete') return operation.result;
        if (operation.status === 'failed') throw new Error(operation.message || 'Falha na operação do IXC');
        if (operation.status !== 'running' || !operation.jobId) throw new Error('Resposta inválida da análise. Atualize o sistema e tente novamente.');
        if (Date.now() - startedAt > maxDuration) throw new Error('A operação demorou demais. Faça uma nova análise para conferir o estado atual.');
        await pause(pollInterval, signal);
        operation = await getStatus(operation.jobId, signal);
    }
}
